export default {
    isMobile: state => state.isMobile,
    notifications: state => state.notifications,
    widget: state => state.widget,
    anytimeWidget: state => state.anytimeWidget,
}
